import { useDispatch, useSelector } from "react-redux";
import { useState } from 'react';
import { Button, TextField, Grid } from "@material-ui/core";
import { constructIds } from "../../../config/common";
import { getMessages } from "../../../store/constructs/messages/selectors";
import { checkNameExist } from "../bluePrintComponents/SystemModel/helpers";
import { useForm } from "react-hook-form";
import { basic, validationMessages } from '../../../config/validations';
import { makeStyles } from '@material-ui/core/styles';
import { handleSnackBar } from '../../../store/global/actions';
import { invokePostService } from "../../../store/global/actions";


const useStyles = makeStyles({
    button: {
        height: 53,
        marginLeft: 10
    }
})

export default function CreateMessage({ element, onActionCompletion, onClose }) {

    const classes = useStyles();
    const dispatch = useDispatch();
    const storeMessages = useSelector(getMessages)
    const [isFetching, setIsFetching] = useState(false);

    const { register, handleSubmit, formState: { errors }, setError } = useForm({
        // defaultValues: {
        //     name: element.name
        // }
    });
    const messages = {
        ...validationMessages,
        validate: 'Message with the given name exists'
    }

    const nameExist = (name) => {
        const status = checkNameExist(name, storeMessages)
        return status === true ? false : true
    }

    /** Format initial message */
    const formatMessage = ({ name }) => {
        return {
            // id: shortUuid.generate(),
            name: name,
            type: constructIds.find(item => item.type === "message").id
        }
    }

    const onSave = (data) => {
        let newMesssage = formatMessage(data)
        // dispatch(addMessage(newMesssage));
        setIsFetching(true)
        dispatch(invokePostService('createMessage', { messageData: newMesssage }, []))
            .then(savedData => {
                setIsFetching(false)
                if (savedData.status) {
                    onActionCompletion(savedData?.data)
                    dispatch(handleSnackBar({ open: true, message: `Event type created`, severity: "success" }));
                    setIsFetching(false)
                }
                else {
                    if (savedData?.code === process.env.REACT_APP_FORM_ERROR_CODE) {
                        savedData?.errors?.forEach(error => {
                            setError(error.name, { message: error.message });
                        });
                    }

                    setIsFetching(false)
                }

            })
            .catch(error => {
                console.error(error)
                dispatch(handleSnackBar({ open: true, message: `Event type creation failed`, severity: "error" }));
            });


        // element.message = newMesssage.id
        // dispatch(editEvent(element)); 

        // onActionCompletion("Event type", "add");

    }

    return (
        <Grid container direction={"row"} spacing={3}>
            <Grid item xs={(element.name == undefined || element?.name !== 'Event Types') ? 8 : 10}>
                <TextField
                    name="name"
                    label={"Name"}
                    fullWidth
                    type={"text"}
                    required
                    variant="outlined"
                    inputRef={register({ ...basic })}
                    error={errors?.name ? true : false}
                    // helperText={messages[errors?.name?.type] || (element.id == undefined && 'Enter name to create a new event type')}
                    helperText={errors?.name ? errors.name?.message ? errors.name.message : messages[errors?.name?.type] : '' || (element.id == undefined && 'Enter name to create a new event type')}
                />
            </Grid>
            <Grid item xs={(element.name == undefined || element?.name !== 'Event Types') ? 4 : 2} style={{ display: "flex", justifyContent: (element.name == undefined || element?.name !== 'Event Types') ? "flex-end" : "center" }}>
                {/* <CreateCancel  onCreate={handleSubmit(onSave)} onCancel={onClose} /> */}
                <Button onClick={handleSubmit(onSave)} color="primary" variant="contained" className={classes.button} disabled={isFetching}>
                    {isFetching ? 'Creating..' : 'Create'}
                </Button>
                {(element.name == undefined || element?.name !== 'Event Types') && <Button onClick={onClose} variant="contained" className={classes.button}>
                    Cancel
                </Button>}
            </Grid>

        </Grid>
    )
}
